import { motion } from 'framer-motion';
import { darken } from 'polished';
import styled from 'styled-components';

export const Container = styled(motion.div)`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;

  width: 100vw;
  height: 100vh;

  display: flex;
  align-items: center;
  justify-content: center;
`;

interface IOverlayProps {
  isCentered?: boolean;
}
export const Overlay = styled.div<IOverlayProps>`
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;

  overflow-y: auto;

  display: flex;
  justify-content: center;
  align-items: ${({ isCentered }) => (isCentered ? 'center' : 'flex-start')};

  padding: 1rem;

  position: absolute;
  left: 0;
  top: 0;
`;

export const Body = styled.div<{ maxWidth: number }>`
  max-width: 30rem;
  width: 100%;
  margin: 0rem auto;

  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 5px;
  box-shadow: 0px 3px 15px 0px rgba(0, 0, 0, 0.1);

  position: relative;
  z-index: 101;
`;

export const Header = styled.header`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
  justify-content: space-between;
  padding: 0.6rem 1rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};

  p {
    font-size: 1rem;
    font-weight: bold;
    margin: 0;
    width: 100%;
    color: ${({ theme }) => theme.colors.blue03.color};
  }
`;

export const CloseButton = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;

  padding: 0.5rem;
  background-color: transparent;
  border-width: 0;
  border-radius: 5px;

  transition: 0.3s;

  &:hover {
    background-color: ${({ theme }) => darken(0.1, theme.colors.light.color)};
  }

  svg {
    width: 0.9rem !important;
    height: 0.9rem !important;

    color: ${({ theme }) => theme.colors.dark.color};
  }
`;

export const Content = styled.section`
  padding: 1rem;
`;
